import React, { useEffect, useState } from 'react';
import {
    Portlet,
    PortletBody,
    PortletHeader,
} from "../../../partials/content/Portlet";
import { Grid, IconButton, Tooltip } from '@mui/material';
import { useStatePtr } from '@pure-ptr/react';
import makeStyles from '@mui/styles/makeStyles';
import { PagedTable, BulkActionIconButton } from '../../../common';
import Helmet from 'react-helmet';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import classNames from 'classnames';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { infoToastify } from '../../../util/toast';
import { getPaginationFilter } from '../../../util/pagination';

const DEFAULT_SORT = [{ id: 'percentage', direction: 'desc' }];

const useStyles = makeStyles(theme => ({
    // root: {
    //     display: 'flex',
    //     overflowX: 'auto',
    //     flexDirection: 'column',
    // },
    container: {
        flexGrow: 1,
    },
    icon: {
        fontSize: 17,
        marginTop: 1,
    }
}));

export default function AssociatedPage(props) {
    const { selectAllStatusPending, updateStatusPending, data, fields, refreshChargesPending, filter, timeFilter, customFilter, sort,
        actions: {
            associatedLanding,
            searchGetByName,
            searchReset,
            resetPagedTable,
            selectDeselectAll,
            setSelected,
            refreshAssociatedCharges,
            resetCriteriaWaiting
        }
    } = props;
    const bannerProcessAllPtr = useStatePtr(false);
    const bannerTempOpenPtr= useStatePtr(true);   

    useEffect(() => {
        const pageName = {
            name: 'associated-landing'
        }
        
        resetCriteriaWaiting(pageName.name)

        return function cleanup() {
            resetPagedTable(pageName.name)
            setSelected([])
        }
    }, [searchGetByName, searchReset]);

    const [refresh, setRefresh] = useState(Promise.resolve());
    const classes = useStyles();

    function handleLoad(sort, filter, pagination) {
        associatedLanding(pagination, sort, filter);
    }

    function handleRefresh(processAll=false,action) {
        if(Boolean(processAll)===true){
        infoToastify(<><b>Bulk {action}</b><br/>Bulk {action}  is in Progress, You'll be notified when it's complete.</>);
        return
        }
        setRefresh(Promise.resolve());
        setEnableDialog(null);
    }

    function handleBulkEnable(processAll, selectedIds) {
        const payload = {
            ids: selectedIds,
            enabled: true,
            processAll,
            ...(processAll ? {
                filter: getPaginationFilter(filter || [], 'false', timeFilter || null,[]),
                page: null,
                sort: sort || []
            } : {})
        };
        selectDeselectAll(payload, () => {
            setSelected([]);
            handleRefresh(processAll,'Enable');
        });
    }

    function handleBulkDisable(processAll, selectedIds) {
        const payload = {
            ids: selectedIds,
            enabled: false,
            processAll,
            ...(processAll ? {
                filter: getPaginationFilter(filter || [], 'false', timeFilter || null, []),
                page: null,
                sort: sort || []
            } : {})
        };
        selectDeselectAll(payload, () => {
            setSelected([]);
            handleRefresh(processAll,'Disable');
        });
    }

    function associatedChargesCallback() {
        handleRefresh();
    }

    function handleRefreshAssociatedCharges() {
        refreshAssociatedCharges({}, associatedChargesCallback);
    }

    function tableLevelActions() {
        return (
            <>
                <Grid item>
                    <Tooltip title="Refresh Associated Charges">
                        <IconButton aria-label="enable" size='small' onClick={handleRefreshAssociatedCharges}>
                            <PlayCircleOutlineIcon />
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Grid item>
                    <BulkActionIconButton
                        bannerProcessAllPtr={bannerProcessAllPtr}
                        isBannerOpen={bannerTempOpenPtr?.value}
                        pageName="associated-landing"
                        actionLabel="Enable"
                        onConfirm={handleBulkEnable}
                        icon={<CheckCircleIcon />}
                        size="small"
                        tooltip="Enable"
                        isPending={selectAllStatusPending}
                        color="default"
                    />
                </Grid>
                <Grid item>
                    <BulkActionIconButton
                        bannerProcessAllPtr={bannerProcessAllPtr}
                        isBannerOpen={bannerTempOpenPtr?.value}
                        pageName="associated-landing"
                        actionLabel="Disable"
                        onConfirm={handleBulkDisable}
                        icon={<i className={classNames("fa fa-solid fa-ban", classes.icon)}></i>}
                        size="small"
                        tooltip="Disable"
                        isPending={selectAllStatusPending}
                        color="default"
                    />
                </Grid>
            </>
        );
    }

    return (
        <>
            <Helmet title="Associated Charges" />
            <Portlet className={classes.root}>
                <PortletHeader title="Associated Charges"
                    name="associated-landing"
                    showSearchFilters={true}
                    showSearchFiltersDropdown={false}
                    handleRefresh={handleRefresh}
                />
                <PortletBody>
                    <div className={classes.container}>
                        <Grid container>
                            <Grid item xs={12}>
                                <PagedTable
                                    name="associated-landing"
                                    shouldRenderLazy={true}
                                    fields={fields}
                                    data={data}
                                    bannerProcessAllPtr={bannerProcessAllPtr}
                                    showSelectAllBanner={true}
                                    onLoad={handleLoad}
                                    refresh={refresh}
                                    bannerTempOpenPtr={bannerTempOpenPtr}
                                    defaultSort={DEFAULT_SORT}
                                    tableLevelActions={tableLevelActions}
                                    hasCheckbox={true}
                                    showSelectAll={true}
                                    timeFilterField={true}
                                    loading={updateStatusPending || selectAllStatusPending || refreshChargesPending}
                                    criteriasSaveEnabled={true}
                                    showSearchFilters={true}
                                />
                            </Grid>
                        </Grid>
                    </div>
                </PortletBody>
            </Portlet>
        </>
    );
}